import {defineStore} from "pinia";
import {Ref} from "vue";
import {adminService} from "@/features/admin/admin.service";
import {IAdminUser} from "@/features/admin/admin.types";

export const useAdminStore = defineStore("admin", () => {

    async function getUsers(
        loading: Ref
    ): Promise<IAdminUser[]> {
        try {
            loading.value = true
            const {data} = await adminService.getUsers()
            return data
        } finally {
            loading.value = false
        }
    }

    async function createUser(
        loading: Ref,
        payload: IAdminUser
    ) {
        try {
            loading.value = true
            const {data} = await adminService.createUser(payload)
            return data
        } finally {
            loading.value = false
        }
    }

    async function updateUser(
        loading: Ref,
        payload: IAdminUser,
        id: number
    ) {
        try {
            loading.value = true
            const {data} = await adminService.updateUser(payload, id)
            return data
        } finally {
            loading.value = false
        }
    }

    async function deleteUser(
        loading: Ref,
        id: number
    ) {
        try {
            loading.value = true
            const {data} = await adminService.deleteUser(id)
            return data
        } finally {
            loading.value = false
        }
    }

    return {getUsers, createUser, updateUser, deleteUser};
});
